<template>
  <Field
    v-if="useVeeValidate"
    v-slot="{ field, errors }"
    v-model="internalValue"
    :name="name"
    :rules="rules"
  >
    <input
      v-if="type !== 'textarea'"
      v-bind="field"
      :class="{
        'Field--fill': fill,
        'Field--error': !!error || errors.length > 0,
      }"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      class="Field"
      @input="updateValue"
      @change="updateValue"
      @blur="$emit('blur', $event.target.value)"
    />
    <textarea
      v-else
      v-bind="field"
      :class="{
        'Field--fill': fill,
        'Field--error': !!error || errors.length > 0,
      }"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      class="Field Field--textarea"
      @input="updateValue"
      @change="updateValue"
      @blur="$emit('blur', $event.target.value)"
    />
  </Field>
  <template v-else>
    <input
      v-if="type !== 'textarea'"
      :class="{ 'Field--fill': fill, 'Field--error': !!error }"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      class="Field"
      @input="updateValue"
      @change="updateValue"
      @blur="$emit('blur', $event.target.value)"
    />
    <textarea
      v-else
      :class="{ 'Field--fill': fill, 'Field--error': !!error }"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      class="Field Field--textarea"
      @input="updateValue"
      @change="updateValue"
      @blur="$emit('blur', $event.target.value)"
    />
  </template>
</template>

<script>
import './style.scss'
import VueTypes from 'vue-types'
import { Field } from 'vee-validate'

export default {
  name: 'CustomField',
  components: {
    Field,
  },
  $_veeValidate: {
    name() {
      return this.name
    },
    value() {
      return this.value
    },
  },
  emits: ['blur', 'input'],
  props: {
    type: { type: String, required: false, defaultValue: 'text' },
    value: VueTypes.any,
    placeholder: { type: String, required: false, defaultValue: '' },
    fill: { type: Boolean, required: false, defaultValue: false },
    name: { type: String },
    error: { type: String, required: false },
    rules: { type: String, required: false },
    useVeeValidate: { type: Boolean, default: false },
  },
  data() {
    return {
      internalValue: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
    internalValue(newVal) {
      this.$emit('input', newVal)
    },
  },
  methods: {
    updateValue(e) {
      this.internalValue = e.target.value
      this.$emit('input', e.target.value)
    },
  },
}
</script>
